import { getAuth, onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../logo.svg";

export default function Header() {
	const [pageState, setPageState] = useState("Sign in");
	const navigate = useNavigate();
	const auth = getAuth();
	useEffect(() => {
		onAuthStateChanged(auth, (user) => {
			if (user) {
				setPageState("Profile");
			} else setPageState("Sign in");
		});
	});

	function onLogout() {
		auth.signOut();
		navigate("/");
	}

	return (
		<div className="navbar bg-cyan-800 z-40 shadow-lg font-semibold uppercase">
			<div className="navbar-start">
				<div className="dropdown">
					<label
						tabIndex={0}
						className="btn btn-ghost lg:hidden"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-5 w-5"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M4 6h16M4 12h8m-8 6h16"
							/>
						</svg>
					</label>
					<ul
						tabIndex={0}
						className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
					>
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/sign-up">Sign Up</Link>
						</li>
						<li>
							<Link to="/profile"> {pageState} </Link>
						</li>
					</ul>
				</div>
				<Link
					to="/"
					className="btn btn-ghost normal-case text-xl"
				>
					<img
						className="w-50 h-10 pt-1"
						src={logo}
						alt="logo"
					/>
				</Link>
			</div>
			<div className="navbar-center hidden lg:flex">
				<ul className="menu menu-horizontal px-1">
					<li>
						<Link to="/">Home</Link>
					</li>
					<li>
						<Link to="/sign-up">Sign Up</Link>
					</li>
					<li>
						<Link to="/profile">{pageState}</Link>
					</li>
				</ul>
			</div>
			<div className="navbar-end">
				{pageState.toLowerCase() === "profile" ? (
					<button
						className="btn"
						onClick={onLogout}
					>
						Log Out
					</button>
				) : (
					<Link to="/sign-in">
						<button className="btn">Sign In</button>
					</Link>
				)}
			</div>
		</div>
	);
}
